// extracted by mini-css-extract-plugin
export default {"item__title":"EditDialog_item__title__IyZOw font-md-regular","item__subTitle":"EditDialog_item__subTitle__LZsm- font-xs-regular"};